import { createBrowserHistory } from "history";
import { logWebLoginSequence, summarizeLocation } from "./utils/webLoginSequenceLogger";

const browserHistory = createBrowserHistory();

const originalPush = browserHistory.push.bind(browserHistory);
const originalReplace = browserHistory.replace.bind(browserHistory);

browserHistory.push = (path, state) => {
	logWebLoginSequence("history.push", {
		target: summarizeLocation(path),
		hasState: !!state
	});
	return originalPush(path, state);
};

browserHistory.replace = (path, state) => {
	logWebLoginSequence("history.replace", {
		target: summarizeLocation(path),
		hasState: !!state
	});
	return originalReplace(path, state);
};

browserHistory.listen((location, action) => {
	logWebLoginSequence("history.location.changed", {
		action,
		target: summarizeLocation(location)
	});
});

export default browserHistory;
